<!-- Delete/Cancel conversion dialog -->
<p-dialog
  [modal]="true"
  [(visible)]="isArchiveDialogOpen"
  (onHide)="toggleArchiveConversionDialog(false)"
>
  <ng-template #headless>
    <div
      class="min-h-[489px] xlplus:min-h-[398px] w-[680px] max-w-[95vw] p-[32px] rounded-2xl bg-white"
    >
      <div>
        <h3 class="font-inter font-semibold text-[22px] xlplus:text-2xl">
          Delete XBRL Conversion File
        </h3>
      </div>
      <div class="font-inter font-normal text-[15px] mt-4">
        You are about to permanently delete the following XBRL Conversion File :
      </div>
      <div class="mt-[24px]">
        <form
          [formGroup]="archiveFormGroup"
          (ngSubmit)="archiveConversion()"
          class="text-sm xlplus:text-base"
        >
          <!-- One value, clamped to two lines, full text in a tooltip only when it is cut off. -->
          <ng-template #clampedValue let-text>
            <span
              appOverflowTooltip
              #valueClamp="overflowTooltip"
              class="w-full line-clamp-2 break-all"
              tooltipPosition="top"
              tooltipStyleClass="top-tooltip"
              [pTooltip]="text"
              [tooltipDisabled]="!valueClamp.isOverflowing()"
            >
              {{ text }}
            </span>
          </ng-template>
          <div class="flex flex-col gap-4 mt-[24px]">
            <div class="flex flex-row gap-3 2xl:gap-[20px]">
              <label class="w-[190px] shrink-0 whitespace-nowrap font-bold">Client Company</label>
              <div class="flex-1 min-w-0">
                <ng-container
                  *ngTemplateOutlet="clampedValue; context: { $implicit: conversionData.company }"
                ></ng-container>
              </div>
            </div>
            <div class="flex flex-row gap-3 2xl:gap-[20px]">
              <label class="w-[190px] shrink-0 whitespace-nowrap font-bold">Status</label>
              <div class="flex-1 min-w-0">
                <ng-container
                  *ngTemplateOutlet="clampedValue; context: { $implicit: (MbrsStatusEnum[conversionData.status] | addSpaces) }"
                ></ng-container>
              </div>
            </div>
            <div class="flex flex-row gap-3 2xl:gap-[20px]">
              <label class="w-[190px] shrink-0 whitespace-nowrap font-bold">Created Date</label>
              <div class="flex-1 min-w-0">
                {{ conversionData.conversionDate ? (conversionData.conversionDate | date : "dd MMM yyyy  hh:mm a") : "-" }}
              </div>
            </div>
            <div class="flex flex-row gap-3 2xl:gap-[20px]">
              <label class="w-[190px] shrink-0 whitespace-nowrap font-bold">Created By</label>
              <div class="flex-1 min-w-0">
                <ng-container
                  *ngTemplateOutlet="clampedValue; context: { $implicit: conversionData.createdBy || '-' }"
                ></ng-container>
              </div>
            </div>
            <div class="flex flex-row gap-3 2xl:gap-[20px]">
              <label class="w-[190px] shrink-0 whitespace-nowrap font-bold">Last Modified Date</label>
              <div class="flex-1 min-w-0">
                {{ conversionData.updatedDate ? (conversionData.updatedDate | date : "dd MMM yyyy  hh:mm a") : "-" }}
              </div>
            </div>
            <div class="flex flex-row gap-3 2xl:gap-[20px]">
              <label class="w-[190px] shrink-0 whitespace-nowrap font-bold">Last Modified By</label>
              <div class="flex-1 min-w-0">
                <ng-container
                  *ngTemplateOutlet="clampedValue; context: { $implicit: conversionData.updatedBy || '-' }"
                ></ng-container>
              </div>
            </div>
          </div>
          <div class="font-inter font-normal text-[16px] mt-8">
            This action will permanently remove all data associated with this
            XBRL Conversion. It cannot be undone. Are you sure you want to
            proceed?
          </div>
          <div class="flex gap-1 justify-end mt-[28px]">
            <p-button
              label="Cancel"
              variant="outlined"
              styleClass="!w-[80px] xlplus:!w-[100px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !mr-2 !text-sm xlplus:!text-base !min-w-[89px] hover:!bg-[#E0F2FE]"
              (onClick)="toggleArchiveConversionDialog(false)"
            >
            </p-button>
            <p-button
              [disabled]="isArchiving"
              type="submit"
              [loading]="isArchiving"
              severity="danger"
              styleClass="!min-w-[80px] xlplus:!min-w-[100px] !text-sm xlplus:!text-base !font-lato !font-bold !text-base  disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
            >
              Delete
            </p-button>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!--
  Self-owned error-toast outlet. Kept OUTSIDE <p-dialog> so it survives the dialog
  closing on failure, and co-located here so it shares this component's injected
  MessageService instance on every host (listing and conversion form) — see the
  archiveConversion() else-branch for why the host outlet can't be relied on.
-->
<interactive-toast [key]="'delete_conversion_error'"></interactive-toast>
